<template>
  <div
    id="chr-achievements-progress"
    class="tw-flex tw-flex-col tw-items-start tw-gap-[40px] tw-self-stretch tw-bg-[#ffffff]"
  >
    <div
      class="tw-w-full tw-flex tw-justify-center tw-items-start tw-flex-col tw-gap-[12px] !tw-break-inside-avoid"
    >
      <div class="tw-flex tw-justify-between tw-w-[100%] tw-h-[36px]">
        <div
          id="chr-sheading-achievement"
          class="tw-text-[#211F58] tw-text-[24px] tw-font-semibold"
        >
          {{
            getComponentUiText("app-report-achievements-and-progress-title-1")
          }}
        </div>

        <div
          id="pen-icon-achievements"
          :class="isEdit ? 'is_editable' : 'not_editable'"
          class="header__pen tw-cursor-pointer"
          @click="editNotes"
        >
          <Pen :color="isEdit ? '#ffffff' : '#387DFF'" />
        </div>
      </div>
      <div
        class="tw-text-[#231F20] tw-text-[14px] tw-font-normal tw-w-[70%] tw-opacity-[0.7]"
      >
        {{
          getComponentUiText("app-report-achievements-and-progress-sub-title-1")
        }}
      </div>
    </div>
    <AchievementsAndProgressTable
      :data="customTableData"
      :is-show-edit="isEdit"
      :is-loading="isLoading"
      @on-form-invalid="(val) => emit('on-form-invalid', val)"
    />
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import { computed, Ref } from "vue";
import AchievementsAndProgressTable from "./achievementsAndProgressTable.vue";
import Pen from "@/components/svgs/pen.vue";
import store from "@/store";

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: true,
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
});
const customTableData = computed(() => {
  const data = store.getters["Sharing/getChecklistReportData"];
  if (!data?.checklistHistory) return [];

  return data.checklistHistory.map((item, idx, arr) => {
    const score = Math.round(item.checklistHistoryScore * 100);
    const nextScore =
      idx < arr.length - 1
        ? Math.round(arr[idx + 1].checklistHistoryScore * 100)
        : score;
    return {
      ...item,
      checklistHistoryScore: score,
      checklistHistoryImprovementScore: score - nextScore,
    };
  });
});

const emit = defineEmits(["update:edit", "on-form-invalid"]);

const editNotes = () => {
  emit("update:edit", !props.isEdit);
};
</script>

<style lang="scss" scoped>
.header__pen {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  padding: 9px 14px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  width: 46px;
  height: 44px;
}

.is_editable {
  background: var(--Brand-Navy, #211f58);
}

.not_editable {
  background: var(--UI-white, #fff);
}

@media print {
  :deep(.table-header) {
    background-color: #211f58 !important;
  }
  #pen-icon-achievements {
    display: none;
  }
}
</style>
